<template>
	<joy-page :joyPageStatus="joyPageStatus">
	<div class="setHeightFullWhite marginTopXm">
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
		<template v-if="list.length==0">
			<noneData></noneData>
		</template>
		<template v-else>
			<div class="cu-timeline" v-for="(item,index) in list" :key="index">
			<div class="cu-time">{{item.day}}</div>
			<div class="cu-item icon-noticefill" style="display: flex;flex-direction: row;justify-content: space-between;">
				<div v-bind:class="item.status==0?'content shadow-blur':'content bg-green shadow-blur'">                                                  <van-tag round type="warning">{{item.over_time}}</van-tag>
					<div v-bind:class="item.status==0?'pliu text-black shadow-blur':'pliu text-gwhite shadow-blur'" style="padding: 10px 0;">                <van-collapse  v-model="activeName" accordion>
						  <van-collapse-item title-class="collapseTitle" label-class="collapseLabel" :title="item.title"  :name="index+1">{{item.describe}}</van-collapse-item>
						</van-collapse>
					</div>
					<!-- <div class="pliu">
					{{item.describe}} 
					
					</div> -->
				</div>
				<div v-if="editable==1" class="radioChoice" @click="checkboxChange(item.id)">
					<img v-show="item.checked" :src="checkboxSelected" style="width: 100%;height: 100%;" mode=""></img>
					<img v-show="!item.checked" :src="checkboxUnSelected" style="width: 100%;height: 100%;" mode=""></img>
				</div>
				<div v-else class="radioChoice" @click="noTouch">
					<img v-show="item.checked" :src="checkboxSelected" style="width: 100%;height: 100%;" mode=""></img>
					<img v-show="!item.checked" :src="checkboxUnSelected" style="width: 100%;height: 100%;" mode=""></img>
				</div>
			</div>
		</div>
		</template>
		</van-pull-refresh>
	</div>
	</joy-page>
</template>

<script>
	export default{
		props:['camp_id','user_id','type'],
		data(){
			return{
				activeName:"",
				list:[],
				checkboxSelected:this.$mAssetsPath.checkboxSelected,
				checkboxUnSelected:this.$mAssetsPath.checkboxUnSelected,
				editable:'',
				locationMsg:'',
				joyPageStatus:'',
				isLoading: false,
			}
		},
		methods:{
			getLocation(){
				const that=this;
				let link = window.location.href;
				const url = "https://api.jiarixiaodui.com/v1/wx/config?url=" + encodeURIComponent(link);
				this.$axios.get(url).then(res => {
					let data=res.data;
						that.$wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
							appId: data.appId, // 必填，公众号的唯一标识
							timestamp: data.timestamp, // 必填，生成签名的时间戳
							nonceStr: data.nonceStr, // 必填，生成签名的随机串
							signature: data.signature, // 必填，签名，见附录1
							jsApiList: ["getLocation"]
						});
						that.$wx.ready(function() {
						that.$wx.getLocation({
							type: 'wgs84',
							 success: function (res) {
								console.log('res是',res);
								let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
								let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
								let locationMsg={
									latitude:latitude.toString(),
									longitude:longitude.toString()
								}
								that.locationMsg=locationMsg;
								console.log(locationMsg);
							},
							fail(res) {
								that.$toast.loading({
								  mask: true,
								  message: '加载中...'
								});
								setTimeout(function () {
									that.$toast.clear();
									window.location.reload();
								}, 500);
							},
							cancel: function(res) {
								alert('您已拒绝授权获取地理位置');
							}
						});
					});
				})
			},
			onRefresh() {
				setTimeout(() => {
					this.isLoading = false;
					this.reload();
					this.$toast('刷新成功');
				}, 1000);
			},
			reload(){
				this.list=[];
				this.editable=null;
				this.loadTask();
			},
			checkboxChange(id){
				const that=this;
				that.$toast.loading({
				  mask: true,
				  message: '加载中...',
				});
				try{
					for (let i in that.list) {
						if(that.list[i].id==id){
							if(!that.list[i].checked){
								// let query={"task_id":id,"latitude":121,"longitude":131};
								this.$axios.put("task/update",{"task_id":id,"latitude":that.locationMsg.latitude,"longitude":that.locationMsg.longitude}).then(res => {
									if(res.data.code==200){
										  that.$toast.clear();
										  that.list[i].checked=true;
										  that.list[i].status=1;
										  setTimeout(function() {
										  	that.$toast.success(res.data.msg);
										  },100);
									}else{
										that.$toast.clear();
									    that.list[i].checked=false;
										setTimeout(function() {
											that.$toast.fail(res.data.msg);
										},100);
									}
								})
							}else{
								that.$toast.fail('已经打过卡了');
							}
						}
					}
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
			noTouch(){
				this.$dialog.alert({
				  title: '提示',
				  message: '暂无权限打卡'
				})
			},
			loadTask(){
				this.joyPageStatus = 'loading';
				try{
					this.$axios.get('task/list?camp_id='+this.camp_id+'&user_id='+this.user_id+'&type='+this.type).then(res => {
						this.joyPageStatus = 'success';
						if (res.data.code == 200) {
							
							this.list=res.data.data;
							this.editable=res.data.editable;
							for (let j in this.list){
												const time=this.list[j].over_time.split(' ');
												this.list[j].day=time[0];
												this.list[j].time=time[1];
												const ot=this.list[j].time.split(':');
												this.list[j].tm=ot[0]>11?'下午':'上午';
												if(this.list[j].status==0){
													this.list[j].checked=false;
												}else{
													this.list[j].checked=true;
												};
												// this.list.[j].title
												 this.list[j].describe='四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅四大佛教圣地就覅圣诞节覅设计的覅'
							};
						}
					}).catch(function (error) {
					  this.joyPageStatus = 'fail';
					});
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
			
		
		},
		created() {
			this.loadTask();
			this.getLocation();
		},
		activated(){
		 
		}
	}
	
</script>
<style>
	.pliu .van-cell{
		/* background: red; */
	} 
	.collapseTitle{
		font-size: 14px;
	}
	 .collapseLabel{
		font-size: 12px;
	}
</style>
<style scoped="scoped">
	@import url("../../colorui/main.css");
	@import url("../../colorui/icon.css");

	.radioChoice{
			width: 20px;height: 20px;
		}
		.pliu{
			width:230px
		}
</style>